import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges
} from '@angular/core';
import * as moment from "moment";

require('./bringoz-countdown-service-adapter.scss');
@Component({
  standalone: false,
  selector: 'app-bringoz-countdown-service-adapter',
  templateUrl: './bringoz-countdown-service-adapter.html',
  changeDetection:ChangeDetectionStrategy.OnPush
})
export class BringozCountdownServiceAdapterComponent implements OnInit, OnChanges, AfterViewInit {
  @Input() from: number;
  @Input() to: number;
  @Input() statusUpdatedAt: number;
  @Input() countToStart: boolean;
  @Input() countToDate: any;
  @Input() keepCountWhenNegative: boolean;
  @Input() stopCount: boolean;
  @Input() maxCount: any;

  public selectedClass: string;
  public afterTimeWindowClass = 'late';
  public endOfTimeWindowClass = 'end-of-time-window';
  public startOfTimeWindowClass = 'start-of-time-window';

  constructor() {
  }

  ngOnInit() {
    this.selectedClass = '';
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.from && !changes.from.isFirstChange() ||
      changes.to && !changes.to.isFirstChange()) {
      this.changeColors();
    }
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.changeColors();
    }, 0);
  }

  onTimeChanged() {
    setTimeout(() => {
      this.changeColors(true);
    }, 0);
  }

  private changeColors(doUpdate?) {
    if (!!doUpdate || !this.countToStart) {
      const middleOfTimeWindow = (moment(this.to).valueOf() - moment(this.from).valueOf()) / 2;
      const currentTimeStamp = this.statusUpdatedAt ? this.statusUpdatedAt : moment().valueOf();

      this.selectedClass = currentTimeStamp >= this.to ? this.afterTimeWindowClass :
        currentTimeStamp >= this.from + middleOfTimeWindow ? this.endOfTimeWindowClass :
          currentTimeStamp >= this.from ? this.startOfTimeWindowClass : '';
    }
  }

}
